/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { QueuedJobState } from './queuedJobState';


export interface BatchSmsJob { 
    id: string;
    referenceNumber?: string;
    priority: number;
    message?: string;
    username?: string;
    senderId?: string;
    stateId: number;
    createdUtc: Date;
    scheduledDateUtc?: Date;
    expireAtUtc?: Date;
    stateChangeReason?: string;
    stateChangedUtc?: Date;
    destinationCount: number;
    broadcastDestinations?: string;
    smSRouteName?: string;
    creatorId?: string;
    countryCode?: string;
    country?: string;
    rateCost: number;
    totalCost: number;
    queuedJobState: QueuedJobState;
    stateName?: string;
    smsPages: number;
    serviceProviderName?: string;
    requestSource?: string;
}
